<template>
  <div class="page">
    <div class="block">
      <p class="block__status">
        <i class="fa fa-exclamation-circle"></i>
        {{ $t("page.oops.mainheader") }}
      </p>

      <p class="block__text">{{ $t("page.oops.text1") }}</p>
      <p class="block__text">{{ $t("page.oops.text2") }}</p>

      <BotsMessengerBlock />
    </div>
  </div>
</template>

<script>
import BotsMessengerBlock from "@/components/blocks/BotsMessengerBlock.vue";

export default {
  components: {
    BotsMessengerBlock,
  },
  mounted() {
    this.$store.commit("setNumberData", null);
    this.$store.commit("activation/SET_NEXT_STAGE_ACTIVATION", "");
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 0 20px;

  .block {
    box-sizing: border-box;
    width: 100%;
    border-radius: 11px;
    background: var(--block-color);
    padding: 25px 30px;

    &__status {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 0 0 16px;

      font-family: "Gilroy", sans-serif;
      font-size: 24px;
      font-weight: 700;
      line-height: 140%;
      color: var(--danger-second-color);

      i {
        font-size: 28px;
      }
    }

    &__text {
      font-family: "Gilroy", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 25px;
      margin: 0 0 12px;
      color: var(--text-third-color);
    }

    .social {
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 680px) {
    .block {
      padding: 20px 15px;

      &__status {
        font-size: 18px;

        i {
          font-size: 22px;
        }
      }
    }
  }
}
</style>
